import { ErrorBase } from './ErrorBase'

export class BadRequestError extends ErrorBase {
  constructor({ message, cause, code }: { message: string; cause: Error; code?: string }) {
    super({ message, cause, code })
    this.name = 'BadRequestError'
  }
}
